import Head from './pages/header'
import Bottom from './pages/bottom'
import Maps from './map/map'
import Text from './map/text'
import Map from './pages/map'
import Divider from './pages/divider'
import "./index.css"

function App() {
  return (
    <>
    <Head></Head>
    <Maps></Maps>
    <Text></Text>
    <Divider></Divider>
    <Map></Map>
    <Bottom></Bottom>
    </>
  );
}

export default App;
